export default {
  sections: {
    title: {
      title: 'Encomenda confirmada',
      description: 'O seu cartão oferta foi comprado com sucesso',
    },
    instructions: {
      title: 'Verifique o seu e-mail',
      description:
        'Enviámos os detalhes do seu cartão oferta e recibo para o seu endereço de e-mail. O código chegará em 5-10 minutos.',
    },
    details: {
      total: 'Total',
      order_number: 'Número de encomenda',
    },
    footer: {
      help: 'O nosso parceiro tecnológico Foodamigos ajuda-nos a gerir os cartões oferta. Se não receber o cartão oferta ou não o encontrar, contacte-os em {{email}}',
      questions: 'Se tiver dúvidas gerais sobre o resgate, contacte-nos diretamente em {{email}}',
    },
  },
  buttons: {
    go_home: 'Voltar ao início',
    download_pdfs: 'Descarregar PDF do cartão oferta',
  },
};
